const europeWest1 = 'europe-west1';
const usEast1 = 'us-east1';
const belgium = 'Belgium';
const southCarolina = 'South Carolina';

export interface DataRegionType {
  code: typeof europeWest1 | typeof usEast1;
  name: typeof belgium | typeof southCarolina;
}

export const tenantDataRegionTypes = {
  europeWest1: {
    code: europeWest1,
    name: belgium,
  },
  usEast1: {
    code: usEast1,
    name: southCarolina,
  },
} as const;
